export default {
    email: {
        required: true,
        email: true
    },
    accountRole: {
        required: true
    }
}